import { Box, Stack } from '@mui/material';

import { ParticipantTile } from './ParticipantTile';

interface SpeakerViewProps {
  mainStageSessionId: string | null;
  sidebarParticipantIds: string[];
  activeSpeakerId: string | null;
  localSessionId: string;
  isScreenShare?: boolean;
  screenShareSessionId?: string | null;
  fillHeight?: boolean;
}

export function SpeakerView({
  mainStageSessionId,
  sidebarParticipantIds,
  activeSpeakerId,
  localSessionId,
  isScreenShare = false,
  screenShareSessionId,
  fillHeight = false,
}: SpeakerViewProps) {
  const mainSessionId =
    isScreenShare && screenShareSessionId ? screenShareSessionId : mainStageSessionId;

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        ...(fillHeight ? { flex: 1, minHeight: 0 } : { aspectRatio: '16 / 9' }),
        // bgcolor: 'grey.900',
        // borderRadius: '8px',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'row',
      }}
    >
      {/* Main stage */}
      <Box sx={{ flex: 1, minWidth: 0, minHeight: 0 }}>
        {mainSessionId && (
          <ParticipantTile
            sessionId={mainSessionId}
            variant="main"
            isLocal={mainSessionId === localSessionId}
            isActiveSpeaker={mainSessionId === activeSpeakerId}
            isScreenShare={isScreenShare}
          />
        )}
      </Box>

      {/* Sidebar */}
      {sidebarParticipantIds.length > 0 && (
        <Stack
          spacing={1.5}
          sx={{
            width: 220,
            flexShrink: 0,
            overflowY: 'auto',
            pl: 1.5,
          }}
        >
          {sidebarParticipantIds.map(id => (
            <ParticipantTile
              key={id}
              sessionId={id}
              variant="thumbnail"
              isLocal={id === localSessionId}
              isActiveSpeaker={id === activeSpeakerId}
            />
          ))}
        </Stack>
      )}
    </Box>
  );
}
